<header class="header">
  <mat-toolbar class="header__toolbar">
    <svg
      class="header__background"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="none"
      viewBox="0 0 1 1">
      <defs>
        <linearGradient id="header-primary-highlight" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="var(--color-ui-primary)" stop-opacity="0.33" />
          <stop offset="50%" stop-color="var(--color-ui-primary)" stop-opacity="0.17" />
          <stop offset="100%" stop-color="var(--color-ui-primary)" stop-opacity="0.05" />
        </linearGradient>
      </defs>

      <rect width="1" height="1" fill="#fff" />
      <rect width="1" height="1" fill="url(#header-primary-highlight)" />
    </svg>

    <div class="header__container">
      <div class="header__content">
        <a class="header__logo" routerLink="/" aria-label="Home">
          <img src="assets/images/logo.svg" alt="Company Logo" class="header__logo-image" />
        </a>
        <lib-header-desktop-nav [menu]="menu" />
        <div class="header__actions">
          <ng-content select="[headerActions]" />
          <lib-language-selector />

          <button
            mat-icon-button
            class="header__mobile-toggle"
            (click)="toggleMobileMenu()"
            aria-label="Toggle mobile menu"
            [attr.aria-expanded]="isMenuOpen()">
            <mat-icon>{{ isMenuOpen() ? 'close' : 'menu' }}</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <lib-header-mobile-nav [menu]="menu" [isOpen]="isMenuOpen()" (navigated)="closeMobileMenu()" />
</header>
